module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "noMargin"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('div', {
    staticClass: "pageTitle quoteLiteTitle",
    staticStyle: {
      "max-width": "100% !important",
      "width": "100% !important"
    }
  }, [_c('h2', [_vm._v("QUOTES REPORT")])])])], 1)], 1)
},staticRenderFns: []}